/** Montant EUR avec symbole (ex. fr : « 1 280,50 € » ou « 80 € » si entier). */
export const formatMoneyEur = (amount: number, locale: string, options?: { forceDecimals?: boolean }): string => {
  const forceDecimals = options?.forceDecimals ?? false;
  const hasCents =
    forceDecimals || Math.round(Math.abs(amount * 100)) % 100 !== 0;
  const minFractionDigits = hasCents ? 2 : 0;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: 2,
  }).format(amount);
}



/** Chiffres uniquement (pour clés du type « {{amount}} € »). */
export const formatEuroNumber = (amount: number, locale: string, options?: { minimumFractionDigits?: number; maximumFractionDigits?: number }): string => {
  const defaultMin =
    options?.minimumFractionDigits !== undefined
      ? options.minimumFractionDigits
      : Math.round(Math.abs(amount * 100)) % 100 !== 0
        ? 2
        : 0;
  const maxFractionDigits = options?.maximumFractionDigits ?? 2;
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: defaultMin,
    maximumFractionDigits: maxFractionDigits,
  }).format(amount);
}
